import {
  ENVIRONMENT_PAIRING_PATH,
  ENVIRONMENT_PAIRING_TOKEN_PARAM,
} from "@afar-research/contracts";

/**
 * Reads the one-time grant a pairing link carries in its fragment (`/pair#token=…`). The fragment
 * never reaches a server, which is why the grant rides there rather than in the query.
 */
export function readPairingToken(hash: string): string | null {
  const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
  const token = params.get(ENVIRONMENT_PAIRING_TOKEN_PARAM)?.trim();
  return token === undefined || token.length === 0 ? null : token;
}

export function isPairingPath(pathname: string): boolean {
  return pathname === ENVIRONMENT_PAIRING_PATH || pathname === `${ENVIRONMENT_PAIRING_PATH}/`;
}

export type BrowserPairingFailure = "spent" | "malformed" | "refused" | "unreachable";

/** What to tell the person when a pairing link does not work, in terms of what they can do. */
export function describePairingFailure(failure: BrowserPairingFailure): string {
  switch (failure) {
    case "spent":
      return "This pairing link was already used or has expired. Each link works once, for five minutes.";
    case "malformed":
      return "That is not a pairing code. Copy the whole link, or the code after “token=”.";
    case "refused":
      return "The Environment refused this browser. Open the link on the page it was issued for.";
    case "unreachable":
      return "The Environment could not be reached. Check that it is still running.";
  }
}
